import { useLang } from "@/lib/i18n";

/**
 * One day of the week in an editor: its own opening and closing times, and a
 * switch that shuts it. The times stay where they are when a day is closed, so
 * the day can be opened again without retyping them.
 */
export default function HoursDayRow({ day, hours, onHours, onToggle, inputCls, label }) {
  const { lang } = useLang();
  const timeCls = `${inputCls} flex-1 min-w-0 px-2 py-1.5 text-[13px]`;

  return (
    <div className="flex items-center gap-2 py-1">
      <div className="w-[40px] shrink-0 text-[12px] font-bold text-[#3f3f3c]">{day.label}</div>
      <input
        type="time"
        value={hours?.open || ""}
        disabled={!hours}
        onChange={(e) => onHours({ open: e.target.value, close: hours?.close || e.target.value })}
        className={timeCls}
        aria-label={lang === "es" ? day.label + ": abre" : day.label + " opens"}
      />
      <span className="text-[12px] text-[#8d8d88]">–</span>
      <input
        type="time"
        value={hours?.close || ""}
        disabled={!hours}
        onChange={(e) => onHours({ open: hours?.open || e.target.value, close: e.target.value })}
        className={timeCls}
        aria-label={lang === "es" ? day.label + ": cierra" : day.label + " closes"}
      />
      <button
        type="button"
        onClick={onToggle}
        aria-label={label}
        title={label}
        className={`w-9 h-5 shrink-0 rounded-full relative transition-colors ${hours ? "bg-[#171717]" : "bg-[#d4d4cf]"}`}
      >
        <span
          className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-all ${
            hours ? "left-[18px]" : "left-0.5"
          }`}
        />
      </button>
    </div>
  );
}